// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GamesRouteImport } from './routes/games'
import { Route as GameRouteImport } from './routes/game'
import { Route as DevRouteImport } from './routes/dev'
import { Route as ChallengesRouteImport } from './routes/challenges'
import { Route as ChallengeRouteImport } from './routes/challenge'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GamesGameModeIdRouteImport } from './routes/games.$gameModeId'
import { Route as DevRunSummaryRouteImport } from './routes/dev/run-summary'
import { Route as DevPlaygroundRouteImport } from './routes/dev/playground'
import { Route as DevParticlesRouteImport } from './routes/dev/particles'
import { Route as ChallengesChallengeIdRouteImport } from './routes/challenges.$challengeId'

const GamesRoute = GamesRouteImport.update({
            id: '/games',path: '/games',getParentRoute: () => rootRouteImport
          })
const GameRoute = GameRouteImport.update({
            id: '/game',path: '/game',getParentRoute: () => rootRouteImport
          })
const DevRoute = DevRouteImport.update({
            id: '/dev',path: '/dev',getParentRoute: () => rootRouteImport
          })
const ChallengesRoute = ChallengesRouteImport.update({
            id: '/challenges',path: '/challenges',getParentRoute: () => rootRouteImport
          })
const ChallengeRoute = ChallengeRouteImport.update({
            id: '/challenge',path: '/challenge',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GamesGameModeIdRoute = GamesGameModeIdRouteImport.update({
            id: '/$gameModeId',path: '/$gameModeId',getParentRoute: () => GamesRoute
          })
const DevRunSummaryRoute = DevRunSummaryRouteImport.update({
            id: '/run-summary',path: '/run-summary',getParentRoute: () => DevRoute
          })
const DevPlaygroundRoute = DevPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => DevRoute
          })
const DevParticlesRoute = DevParticlesRouteImport.update({
            id: '/particles',path: '/particles',getParentRoute: () => DevRoute
          })
const ChallengesChallengeIdRoute = ChallengesChallengeIdRouteImport.update({
            id: '/$challengeId',path: '/$challengeId',getParentRoute: () => ChallengesRoute
          })





const ChallengesRouteChildren = {
  ChallengesChallengeIdRoute: ChallengesChallengeIdRoute
}

const ChallengesRouteWithChildren = ChallengesRoute._addFileChildren(ChallengesRouteChildren)




const DevRouteChildren = {
  DevParticlesRoute: DevParticlesRoute,DevPlaygroundRoute: DevPlaygroundRoute,DevRunSummaryRoute: DevRunSummaryRoute
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)




const GamesRouteChildren = {
  GamesGameModeIdRoute: GamesGameModeIdRoute
}

const GamesRouteWithChildren = GamesRoute._addFileChildren(GamesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ChallengeRoute: ChallengeRoute,ChallengesRoute: ChallengesRouteWithChildren,DevRoute: DevRouteWithChildren,GameRoute: GameRoute,GamesRoute: GamesRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)